import type { ICategory } from "app/common/services/categoryService.types";
import type { Translate } from "app/filters/i18nFilter";
import { CustomCategoryErrorsKeys, MAX_ALLOWED_INDUSTRY_NAME } from "../MarketBuilder.types";
import { allTrackers } from "app/services/track/track";
import type { AssetNameValidationResult } from "app/services/user-asset-name/userAssetNameUtils";
import { userAssetNameUtils } from "app/services/user-asset-name/userAssetNameUtils";

const EVENT_CATEGORY = "Button";
const EVENT_ACTION = "click";

export const validateMarketName = (
    name: string,
    userCategories: ICategory[],
    translate: Translate,
    categoryId: string,
): AssetNameValidationResult => {
    const { errorBuilder, isEmptyName, isLongerThanMaxLength, hasInvalidCharacters } = userAssetNameUtils;
    const error = errorBuilder();

    if (isEmptyName(name)) {
        allTrackers.trackEvent(EVENT_CATEGORY, EVENT_ACTION, `nameCustomIndustry/error message/empty name`);
        return error(CustomCategoryErrorsKeys.emptyName);
    }

    if (isLongerThanMaxLength(name, MAX_ALLOWED_INDUSTRY_NAME)) {
        allTrackers.trackEvent(EVENT_CATEGORY, EVENT_ACTION, `nameCustomIndustry/error message/long name`);
        return error(CustomCategoryErrorsKeys.longName);
    }

    if (hasInvalidCharacters(name, false)) {
        allTrackers.trackEvent(EVENT_CATEGORY, EVENT_ACTION, `nameCustomIndustry/error message/invalid charecter`);
        return error(CustomCategoryErrorsKeys.invalidCharacter);
    }

    if (isDuplicateName(name, userCategories, categoryId)) {
        allTrackers.trackEvent(EVENT_CATEGORY, EVENT_ACTION, `nameCustomIndustry/error message/duplicate name`);
        return error(CustomCategoryErrorsKeys.duplicateName);
    }

    return { isValid: true };
};

const isDuplicateName = (name: string, userCategories: ICategory[], categoryId) => {
    const hasCategoryWithSameName = userCategories.some(
        (category) => category.name === name && category.categoryId !== categoryId,
    );
    return hasCategoryWithSameName;
};
